var map = {
	"./Account/PlayerType/beginner_player.svg": 54319,
	"./Account/PlayerType/pro_player.svg": 86658,
	"./Account/PlayerType/pro_player_disabled.svg": 75914,
	"./Animation/10s": 2364,
	"./Animation/10s.json": 2364,
	"./Animation/20s": 89650,
	"./Animation/20s.json": 89650,
	"./Animation/30s": 68433,
	"./Animation/30s.json": 68433,
	"./Animation/Blitz": 37107,
	"./Animation/Blitz.json": 37107,
	"./Animation/Bullet": 13145,
	"./Animation/Bullet.json": 13145,
	"./Animation/CaissaHello_animation.riv": 72442,
	"./Animation/CaissaSuccess_animation.riv": 39880,
	"./Animation/Calculation_Trainer/Calculation_Trainer": 79409,
	"./Animation/Calculation_Trainer/Calculation_Trainer.json": 79409,
	"./Animation/Challenge_a_friend.riv": 38960,
	"./Animation/Classical": 61845,
	"./Animation/Classical.json": 61845,
	"./Animation/Didnt_find_any_opponent.riv": 78280,
	"./Animation/Intuition_Trainer/Intuition_Trainer": 47517,
	"./Animation/Intuition_Trainer/Intuition_Trainer.json": 47517,
	"./Animation/Play_against_Caissa_Bot.riv": 86596,
	"./Animation/Play_random_opponent.riv": 14715,
	"./Animation/Practice_from_a_position.riv": 73820,
	"./Animation/Rapid": 71178,
	"./Animation/Rapid.json": 71178,
	"./Animation/Search": 38949,
	"./Animation/Search.json": 38949,
	"./Animation/Snail": 99040,
	"./Animation/Snail.json": 99040,
	"./Animation/Solve_Puzzles/Solve_Puzzles": 99282,
	"./Animation/Solve_Puzzles/Solve_Puzzles.json": 99282,
	"./Animation/Square_Trainer/Square_training": 19919,
	"./Animation/Square_Trainer/Square_training.json": 19919,
	"./Animation/Start_new_game/v1": 67339,
	"./Animation/Start_new_game/v1.json": 67339,
	"./Animation/Start_new_game/v2": 46004,
	"./Animation/Start_new_game/v2.json": 46004,
	"./Animation/caissa_animation.riv": 53305,
	"./Animation/challenge_animation.riv": 74939,
	"./Animation/challenge_wait": 72226,
	"./Animation/challenge_wait.json": 72226,
	"./Animation/chessboardLoader": 89433,
	"./Animation/chessboardLoader.json": 89433,
	"./Animation/chessboardLoader2": 31222,
	"./Animation/chessboardLoader2.json": 31222,
	"./Animation/circlechess_opponent_matching_animation.riv": 9111,
	"./Animation/didnt_respond.riv": 53680,
	"./Animation/error_boundary_animation": 99901,
	"./Animation/error_boundary_animation.json": 99901,
	"./Animation/error_page_404.lottie": 58014,
	"./Animation/mobileMenuIcon": 93785,
	"./Animation/mobileMenuIcon.json": 93785,
	"./Animation/rejected_your_challenge.riv": 19680,
	"./Animation/successCheck": 2752,
	"./Animation/successCheck.json": 2752,
	"./Animation/under_construction": 70973,
	"./Animation/under_construction.json": 70973,
	"./Annotation/attack.svg": 55026,
	"./Annotation/black_is_better.svg": 74463,
	"./Annotation/black_is_slightly_better.svg": 74734,
	"./Annotation/black_is_winning.svg": 30265,
	"./Annotation/blunder.svg": 9078,
	"./Annotation/brilliant_move.svg": 24311,
	"./Annotation/counter_play.svg": 40575,
	"./Annotation/development.svg": 31249,
	"./Annotation/dubious_move.svg": 92485,
	"./Annotation/equal_position.svg": 38306,
	"./Annotation/good_move.svg": 33275,
	"./Annotation/initiative.svg": 67478,
	"./Annotation/interesting_move.svg": 98535,
	"./Annotation/mistake.svg": 78076,
	"./Annotation/only_move.svg": 57269,
	"./Annotation/time_trouble.svg": 348,
	"./Annotation/unclear_position.svg": 83585,
	"./Annotation/white-color/attack_white.svg": 97696,
	"./Annotation/white-color/black_is_better_white.svg": 20225,
	"./Annotation/white-color/black_is_slightly_better_white.svg": 28610,
	"./Annotation/white-color/black_is_winning_white.svg": 87304,
	"./Annotation/white-color/blunder_white.svg": 82693,
	"./Annotation/white-color/brilliant_move_white.svg": 70534,
	"./Annotation/white-color/counter_play_white.svg": 19604,
	"./Annotation/white-color/development_white.svg": 82867,
	"./Annotation/white-color/dubious_move_white.svg": 37857,
	"./Annotation/white-color/equal_position_white.svg": 58718,
	"./Annotation/white-color/good_move_white.svg": 1662,
	"./Annotation/white-color/initiative_white.svg": 26441,
	"./Annotation/white-color/interesting_move_white.svg": 23518,
	"./Annotation/white-color/mistake_white.svg": 22391,
	"./Annotation/white-color/only_move_white.svg": 20387,
	"./Annotation/white-color/time_trouble_white.svg": 18697,
	"./Annotation/white-color/unclear_position_white.svg": 88260,
	"./Annotation/white-color/white_is_better_white.svg": 16738,
	"./Annotation/white-color/white_is_slightly_better_white.svg": 48123,
	"./Annotation/white-color/white_is_winning_white.svg": 81796,
	"./Annotation/white-color/with_compensation_white.svg": 95002,
	"./Annotation/white-color/with_the_idea_white.svg": 66964,
	"./Annotation/white-color/zugzwand_white.svg": 7705,
	"./Annotation/white_is_better.svg": 21588,
	"./Annotation/white_is_slightly_better.svg": 94677,
	"./Annotation/white_is_winning.svg": 80994,
	"./Annotation/with_compensation.svg": 82560,
	"./Annotation/with_the_idea.svg": 13632,
	"./Annotation/zugzwand.svg": 67657,
	"./Badges/1stPrize.png": 84320,
	"./Badges/2ndPrize.png": 18366,
	"./Badges/3rdPrize.png": 97681,
	"./ChessPieces/Black-Bishop.svg": 37483,
	"./ChessPieces/Black-King.svg": 55446,
	"./ChessPieces/Black-Knight.svg": 78256,
	"./ChessPieces/Black-Pawn.svg": 84602,
	"./ChessPieces/Black-Queen.svg": 22636,
	"./ChessPieces/Black-Rook.svg": 67214,
	"./ChessPieces/White-Bishop.svg": 20230,
	"./ChessPieces/White-King.svg": 87206,
	"./ChessPieces/White-Knight.svg": 87017,
	"./ChessPieces/White-Pawn.svg": 13875,
	"./ChessPieces/White-Queen.svg": 12287,
	"./ChessPieces/White-Rook.svg": 28649,
	"./Dashboard/BeginnerOrPro/beginner_image.svg": 89386,
	"./Dashboard/BeginnerOrPro/pro_image.svg": 88018,
	"./Dashboard/PlayOnline/chessboardBg__PlayChess.svg": 51984,
	"./Dashboard/PlayOnline/playChessIcon.svg": 35921,
	"./Dashboard/SolvePuzzle/puzzleBg.svg": 35646,
	"./Dashboard/StreakDropdownBg/streak_dropdown_bg.svg": 47554,
	"./Eco/eco": 15055,
	"./Eco/eco.json": 15055,
	"./Fonts/DMSans-Medium.ttf": 33801,
	"./Fonts/DMSans-Regular.ttf": 75660,
	"./Fonts/DMSans-SemiBold.ttf": 13761,
	"./Fonts/ProductSans-Black.ttf": 14606,
	"./Fonts/ProductSans-BlackItalic.ttf": 99136,
	"./Fonts/ProductSans-Bold.ttf": 62334,
	"./Fonts/ProductSans-BoldItalic.ttf": 14502,
	"./Fonts/ProductSans-Italic.ttf": 75669,
	"./Fonts/ProductSans-Light.ttf": 9880,
	"./Fonts/ProductSans-LightItalic.ttf": 48868,
	"./Fonts/ProductSans-Medium.ttf": 35232,
	"./Fonts/ProductSans-MediumItalic.ttf": 26616,
	"./Fonts/ProductSans-Regular.ttf": 34073,
	"./Fonts/ProductSans-Thin.ttf": 42437,
	"./Fonts/ProductSans-ThinItalic.ttf": 58816,
	"./Fonts/THUNDER/Fonts/Web-TT/Thunder-LC.ttf": 28034,
	"./Fonts/THUNDER/Fonts/Web-TT/Thunder-LC.woff": 26088,
	"./Fonts/THUNDER/Fonts/Web-TT/Thunder-LC.woff2": 61849,
	"./Fonts/THUNDER/License/License.pdf": 63826,
	"./Fonts/fontWeightToFamily": 32488,
	"./Fonts/fontWeightToFamily.ts": 32488,
	"./Images/Caissa/Caissa_bot_girl.svg": 93897,
	"./Images/Caissa/Caissa_bot_horse.svg": 60689,
	"./Images/Caissa/PlayAndLearnTabPatternMobile.svg": 8038,
	"./Images/Caissa/PlayModeIcon.svg": 40333,
	"./Images/Caissa/TournamenTab.svg": 980,
	"./Images/Caissa/aqua_chess_pattern.svg": 28892,
	"./Images/Caissa/chatbot/Parental_control_rules.svg": 23472,
	"./Images/Caissa/chatbot/chessboard_stairs_chatbot_bg.svg": 94842,
	"./Images/ChessPieces/Black-Rook.png": 91676,
	"./Images/ChessPieces/Black-Rook.svg": 6704,
	"./Images/ChessPieces/White-Rook.png": 94727,
	"./Images/ChessPieces/White-Rook.svg": 74032,
	"./Images/ChessPieces/whiterookscale.svg": 15042,
	"./Images/Meetings/Coach.svg": 21971,
	"./Images/Meetings/Instructor.svg": 67502,
	"./Images/Meetings/Mentor.svg": 46182,
	"./Images/Meetings/Pattern.svg": 35192,
	"./Images/Meetings/Practice.svg": 77585,
	"./Images/Meetings/csoc_expiry_icon.svg": 6100,
	"./Images/Meetings/csoc_plan_expiring.svg": 95086,
	"./Images/Otb/card_pattern.svg": 78980,
	"./Images/Otb/corner_pattern.svg": 40539,
	"./Images/Otb/otb_image.svg": 4947,
	"./Images/Points/negativePoint.png": 7257,
	"./Images/Points/positivePoint.png": 14956,
	"./Images/RequestAccess/NoPlayer.svg": 57373,
	"./Images/ReviewGame.png": 24927,
	"./Images/Rules-image.png": 86700,
	"./Images/Svgs/14_days_renew_icon.svg": 57261,
	"./Images/Svgs/BeginnerDashboard/Background.svg": 89703,
	"./Images/Svgs/BeginnerDashboard/Chessboard.svg": 2765,
	"./Images/Svgs/BeginnerDashboard/FindSquare.svg": 53081,
	"./Images/Svgs/BeginnerDashboard/Intersect.svg": 77275,
	"./Images/Svgs/BeginnerDashboard/IntersectPattern.svg": 77434,
	"./Images/Svgs/BeginnerDashboard/LearningRoadmap.svg": 36493,
	"./Images/Svgs/BeginnerDashboard/PlayAGame.svg": 97345,
	"./Images/Svgs/BeginnerDashboard/PracticePosition.svg": 28382,
	"./Images/Svgs/BeginnerDashboard/pawnIcon.svg": 53273,
	"./Images/Svgs/Bolt.svg": 85665,
	"./Images/Svgs/Bullet.svg": 81899,
	"./Images/Svgs/CCCurrency": 93832,
	"./Images/Svgs/CCCurrency.tsx": 93832,
	"./Images/Svgs/CCTicketIcon": 77318,
	"./Images/Svgs/CCTicketIcon.tsx": 77318,
	"./Images/Svgs/Ellipse.svg": 19376,
	"./Images/Svgs/ExclamationIcon": 3639,
	"./Images/Svgs/ExclamationIcon.tsx": 3639,
	"./Images/Svgs/IncorrectMove.svg": 43076,
	"./Images/Svgs/IsOngoing.svg": 79636,
	"./Images/Svgs/LeagueDetail.svg": 54142,
	"./Images/Svgs/Parental_control_rules.svg": 49317,
	"./Images/Svgs/Play active.svg": 6341,
	"./Images/Svgs/Play and Learn active.svg": 12314,
	"./Images/Svgs/Play and Learn normal.svg": 83337,
	"./Images/Svgs/Play normal.svg": 75821,
	"./Images/Svgs/Play.svg": 32968,
	"./Images/Svgs/Play_from_any_position.svg": 70014,
	"./Images/Svgs/PlayandLearn.svg": 6700,
	"./Images/Svgs/Rapid.svg": 82998,
	"./Images/Svgs/Rectangle.svg": 34128,
	"./Images/Svgs/Snail.svg": 26590,
	"./Images/Svgs/Summary.svg": 70204,
	"./Images/Svgs/Tournaments.svg": 15919,
	"./Images/Svgs/addMember.svg": 64445,
	"./Images/Svgs/androidqr.jpg": 75026,
	"./Images/Svgs/appModalImage.jpg": 28562,
	"./Images/Svgs/background_frames.svg": 56357,
	"./Images/Svgs/bannerItems/header1.png": 52617,
	"./Images/Svgs/bannerItems/header2.png": 36339,
	"./Images/Svgs/bannerItems/header3.png": 33224,
	"./Images/Svgs/bannerItems/left.png": 82244,
	"./Images/Svgs/bannerItems/right.png": 34057,
	"./Images/Svgs/bannerItems/topHeader.png": 32851,
	"./Images/Svgs/bannerchakra.svg": 45784,
	"./Images/Svgs/beginIg.svg": 11220,
	"./Images/Svgs/blue-chessboard.jpg": 5556,
	"./Images/Svgs/blue.svg": 23477,
	"./Images/Svgs/book-check.svg": 62353,
	"./Images/Svgs/book-open.svg": 50769,
	"./Images/Svgs/bottomShadow.svg": 54369,
	"./Images/Svgs/bottombg.svg": 19821,
	"./Images/Svgs/brief_logo.png": 82054,
	"./Images/Svgs/bronzeMedal.svg": 64299,
	"./Images/Svgs/brownleft.svg": 81402,
	"./Images/Svgs/brownright.svg": 11897,
	"./Images/Svgs/caissaAvatar.svg": 68779,
	"./Images/Svgs/callBgPattern.svg": 11856,
	"./Images/Svgs/cameraPlus.svg": 17036,
	"./Images/Svgs/cc-logo-dark.svg": 20800,
	"./Images/Svgs/cc-logo-light.svg": 80984,
	"./Images/Svgs/ccIcon.svg": 99673,
	"./Images/Svgs/cc_logo.png": 49109,
	"./Images/Svgs/ccleague.svg": 46285,
	"./Images/Svgs/challengehover.svg": 11213,
	"./Images/Svgs/chatLogo.svg": 32211,
	"./Images/Svgs/checksquare.svg": 62667,
	"./Images/Svgs/chessboard.svg": 63467,
	"./Images/Svgs/chesscom.png": 87332,
	"./Images/Svgs/chessdotcom.svg": 97845,
	"./Images/Svgs/chevronDoubleDown.svg": 24719,
	"./Images/Svgs/chevronDoubleUp.svg": 79972,
	"./Images/Svgs/circle_chess_back_half.png": 35711,
	"./Images/Svgs/coinBackgoundForGoals.svg": 24176,
	"./Images/Svgs/coinInRewards.svg": 4580,
	"./Images/Svgs/coming_soon.png": 8988,
	"./Images/Svgs/coming_soon_2.png": 46429,
	"./Images/Svgs/congrats.svg": 94259,
	"./Images/Svgs/connection_change.svg": 57812,
	"./Images/Svgs/correct.svg": 18628,
	"./Images/Svgs/crossCircle.svg": 52302,
	"./Images/Svgs/cursorclick.svg": 48249,
	"./Images/Svgs/custom_positions_tournaments.svg": 49933,
	"./Images/Svgs/download.svg": 50912,
	"./Images/Svgs/endgamewhite.svg": 2791,
	"./Images/Svgs/euros.svg": 20873,
	"./Images/Svgs/expert_cheat_detection.svg": 21728,
	"./Images/Svgs/expired_svg_renewal_icon.svg": 15599,
	"./Images/Svgs/fully_private_games.svg": 32788,
	"./Images/Svgs/gameplay_assistant.svg": 88162,
	"./Images/Svgs/giftIcon.svg": 47563,
	"./Images/Svgs/goldMedal.svg": 88586,
	"./Images/Svgs/green-chessboard.jpg": 52961,
	"./Images/Svgs/green.svg": 60978,
	"./Images/Svgs/greycircle.svg": 42637,
	"./Images/Svgs/hint.svg": 36931,
	"./Images/Svgs/home_page/AI-enabled Caissa.svg": 77519,
	"./Images/Svgs/home_page/Frame.svg": 37668,
	"./Images/Svgs/home_page/Frame1.svg": 4622,
	"./Images/Svgs/home_page/Frame2.svg": 34850,
	"./Images/Svgs/home_page/Frame3.svg": 23963,
	"./Images/Svgs/home_page/PRO.svg": 62535,
	"./Images/Svgs/home_page/Union.svg": 98495,
	"./Images/Svgs/home_page/arrow_down.svg": 2189,
	"./Images/Svgs/home_page/arrow_up.svg": 33381,
	"./Images/Svgs/home_page/assessment.svg": 41061,
	"./Images/Svgs/home_page/badge.svg": 89300,
	"./Images/Svgs/home_page/beginners_curve.svg": 27008,
	"./Images/Svgs/home_page/books_videos.svg": 95245,
	"./Images/Svgs/home_page/bottomLeftSquare.svg": 85625,
	"./Images/Svgs/home_page/bottomRightSquare.svg": 36059,
	"./Images/Svgs/home_page/caissa.svg": 48103,
	"./Images/Svgs/home_page/calculation_trainer.svg": 6944,
	"./Images/Svgs/home_page/chat.svg": 67472,
	"./Images/Svgs/home_page/chess_events.svg": 4475,
	"./Images/Svgs/home_page/chessboard_left_part_large.svg": 47099,
	"./Images/Svgs/home_page/chessboard_part_left.svg": 16073,
	"./Images/Svgs/home_page/chessboard_part_right.svg": 6715,
	"./Images/Svgs/home_page/chessboard_right_part_large.svg": 90246,
	"./Images/Svgs/home_page/cropped_dashboard.svg": 45019,
	"./Images/Svgs/home_page/double_arrow_up.svg": 46399,
	"./Images/Svgs/home_page/four_squares.svg": 86378,
	"./Images/Svgs/home_page/game_analytics.svg": 77296,
	"./Images/Svgs/home_page/game_play.svg": 21114,
	"./Images/Svgs/home_page/intermediate.svg": 11033,
	"./Images/Svgs/home_page/intuition_trainer.svg": 82185,
	"./Images/Svgs/home_page/learning.svg": 39670,
	"./Images/Svgs/home_page/logo.svg": 520,
	"./Images/Svgs/home_page/organisation_trophy.svg": 82484,
	"./Images/Svgs/home_page/parental_control.svg": 80179,
	"./Images/Svgs/home_page/play.svg": 51056,
	"./Images/Svgs/home_page/player.svg": 20112,
	"./Images/Svgs/home_page/positions_trainer.svg": 41391,
	"./Images/Svgs/home_page/review.svg": 59451,
	"./Images/Svgs/home_page/rules.svg": 56636,
	"./Images/Svgs/home_page/signup_assess.svg": 40720,
	"./Images/Svgs/home_page/signup_elevate.svg": 30558,
	"./Images/Svgs/home_page/square.svg": 34467,
	"./Images/Svgs/home_page/square_background.svg": 81998,
	"./Images/Svgs/home_page/sync_obt.svg": 36945,
	"./Images/Svgs/home_page/tournament.svg": 52886,
	"./Images/Svgs/home_page/two_squares.svg": 77323,
	"./Images/Svgs/iosqr.jpg": 3895,
	"./Images/Svgs/knights_elephant.png": 10646,
	"./Images/Svgs/largest_learning_community.svg": 8223,
	"./Images/Svgs/leagueBackground.svg": 95680,
	"./Images/Svgs/learning/arrow.svg": 49274,
	"./Images/Svgs/learning/assessment.svg": 38202,
	"./Images/Svgs/learning/blunder-icon.svg": 31980,
	"./Images/Svgs/learning/gamified-experience.svg": 293,
	"./Images/Svgs/learning/inaccuracy-icon.svg": 73164,
	"./Images/Svgs/learning/master-games.svg": 37118,
	"./Images/Svgs/learning/mistakes-icon.svg": 94955,
	"./Images/Svgs/learning/personalized-content.svg": 56834,
	"./Images/Svgs/learning/slash.svg": 39557,
	"./Images/Svgs/left.svg": 82298,
	"./Images/Svgs/leftbackground.svg": 98031,
	"./Images/Svgs/levelUnitEmpty.svg": 93088,
	"./Images/Svgs/levelUnitEmptyBrown.svg": 99225,
	"./Images/Svgs/levelUnitFilled.svg": 21276,
	"./Images/Svgs/levelUnitFilledBrown.svg": 80083,
	"./Images/Svgs/lichess.png": 4674,
	"./Images/Svgs/lichess.svg": 59498,
	"./Images/Svgs/logo.svg": 18788,
	"./Images/Svgs/logo/logo.svg": 14250,
	"./Images/Svgs/logoicon.svg": 95303,
	"./Images/Svgs/mainappbanner.jpg": 52022,
	"./Images/Svgs/message.svg": 20061,
	"./Images/Svgs/middle.svg": 2768,
	"./Images/Svgs/mobile_bg.svg": 29374,
	"./Images/Svgs/mobile_corner_prize.svg": 90860,
	"./Images/Svgs/new_book_icon.svg": 94265,
	"./Images/Svgs/no_issue_selected.svg": 36515,
	"./Images/Svgs/pattern.svg": 1364,
	"./Images/Svgs/pawnpair.svg": 60161,
	"./Images/Svgs/pawns.svg": 27086,
	"./Images/Svgs/peopleGroup.svg": 87622,
	"./Images/Svgs/person_playing_chess.svg": 48578,
	"./Images/Svgs/phoneCall copy.svg": 69328,
	"./Images/Svgs/phoneCall.svg": 86380,
	"./Images/Svgs/pink.svg": 16854,
	"./Images/Svgs/playerSelected.svg": 63708,
	"./Images/Svgs/playstore.svg": 53596,
	"./Images/Svgs/points.svg": 52957,
	"./Images/Svgs/pointsCoinIcon.svg": 31288,
	"./Images/Svgs/prize.svg": 91395,
	"./Images/Svgs/prizeapp.svg": 24246,
	"./Images/Svgs/prizereminder.svg": 28829,
	"./Images/Svgs/proIg.svg": 983,
	"./Images/Svgs/purple.svg": 8244,
	"./Images/Svgs/puzzle_attempts.svg": 94132,
	"./Images/Svgs/puzzle_timer.svg": 78441,
	"./Images/Svgs/quote.png": 2733,
	"./Images/Svgs/rectangles.svg": 44929,
	"./Images/Svgs/reflects_your_rating.svg": 2447,
	"./Images/Svgs/right.svg": 21615,
	"./Images/Svgs/select_avatar.svg": 50299,
	"./Images/Svgs/silhouette-male-icon.svg": 99438,
	"./Images/Svgs/silverMedal.svg": 38943,
	"./Images/Svgs/singular_ecosystem.svg": 14264,
	"./Images/Svgs/speedometer.svg": 86076,
	"./Images/Svgs/squares.svg": 31671,
	"./Images/Svgs/thumsdown.svg": 42761,
	"./Images/Svgs/thumsdownActive.svg": 98219,
	"./Images/Svgs/thumsup.svg": 1949,
	"./Images/Svgs/thumsupActive.svg": 67133,
	"./Images/Svgs/toprightbg.svg": 58472,
	"./Images/Svgs/tournament_banner/Union.svg": 8507,
	"./Images/Svgs/tournament_banner/background_pattern.svg": 57970,
	"./Images/Svgs/tournament_banner/background_pattern_mobile.svg": 53642,
	"./Images/Svgs/tournament_banner/bannerMain.svg": 48865,
	"./Images/Svgs/tournament_banner/banner_main.svg": 88398,
	"./Images/Svgs/tournament_banner/bg_pattern.svg": 52237,
	"./Images/Svgs/tournament_banner/black_bg_pattern.svg": 3395,
	"./Images/Svgs/tournament_banner/calendar.svg": 70157,
	"./Images/Svgs/tournament_banner/check_icon.svg": 17702,
	"./Images/Svgs/tournament_banner/corner_prize.svg": 97335,
	"./Images/Svgs/tournament_banner/corner_prize_mobile.svg": 38821,
	"./Images/Svgs/tournament_banner/currency-circle.svg": 9015,
	"./Images/Svgs/tournament_banner/detail_pattern.svg": 26620,
	"./Images/Svgs/tournament_banner/gukesh.svg": 71814,
	"./Images/Svgs/tournament_banner/hat.svg": 72130,
	"./Images/Svgs/tournament_banner/image_1.svg": 38425,
	"./Images/Svgs/tournament_banner/image_2.svg": 43194,
	"./Images/Svgs/tournament_banner/image_3.svg": 97462,
	"./Images/Svgs/tournament_banner/onboarding_tournament.svg": 55338,
	"./Images/Svgs/tournament_banner/puzzle.svg": 82456,
	"./Images/Svgs/tournament_banner/yellowBg.svg": 42566,
	"./Images/Svgs/tournament_friends.svg": 19285,
	"./Images/Svgs/trend-up-01.svg": 56929,
	"./Images/Svgs/union.svg": 85176,
	"./Images/Svgs/userIcon.svg": 97748,
	"./Images/Svgs/wrong.svg": 10440,
	"./Images/Svgs/yellow.svg": 79130,
	"./Images/Svgs/yellowleft.svg": 34972,
	"./Images/Svgs/yellowright.svg": 44957,
	"./Images/Svgs/zero_assessments_state.svg": 455,
	"./Images/Tournaments/no_pairing.svg": 4828,
	"./Images/Tournaments/no_standing.svg": 54478,
	"./Images/Tournaments/no_tournament_found.svg": 28114,
	"./Images/Workbook/WorkbookEmptyPage.svg": 71044,
	"./Images/bishop.png": 37303,
	"./Images/cursor-click.svg": 79484,
	"./Images/glyphs/thumbsdown.svg": 52906,
	"./Images/glyphs/thumbsup.svg": 37716,
	"./Images/glyphs/tick.svg": 95525,
	"./Images/hide.svg": 20743,
	"./Images/icons/Rematch.png": 21437,
	"./Images/icons/Rematch@2x.png": 4414,
	"./Images/icons/Rematch@3x.png": 63174,
	"./Images/icons/close.png": 70496,
	"./Images/icons/tick.png": 24892,
	"./Images/icons/tick@2x.png": 15999,
	"./Images/icons/tick@3x.png": 62242,
	"./Images/lock.png": 21925,
	"./Images/pawn.png": 50873,
	"./Images/png/PRO.png": 83081,
	"./Images/png/abort.png": 48122,
	"./Images/png/back_arrow.png": 65840,
	"./Images/png/badge.png": 57854,
	"./Images/png/beginners_curve.png": 54474,
	"./Images/png/black_box.png": 20447,
	"./Images/png/black_color.png": 71001,
	"./Images/png/black_rook.png": 73468,
	"./Images/png/book-closed.png": 837,
	"./Images/png/book.png": 30780,
	"./Images/png/book_dummy.png": 50684,
	"./Images/png/bottom_left_square.png": 81923,
	"./Images/png/bottom_right_square.png": 13117,
	"./Images/png/casual_player.png": 22554,
	"./Images/png/challenge.png": 27861,
	"./Images/png/challenge@2x.png": 24853,
	"./Images/png/challenge@3x.png": 46968,
	"./Images/png/chapter.png": 48548,
	"./Images/png/chart.png": 48113,
	"./Images/png/chat.png": 410,
	"./Images/png/checkmark.png": 5198,
	"./Images/png/chess_events.png": 27906,
	"./Images/png/chess_footer_background.png": 68888,
	"./Images/png/chessboard_left_part_large.png": 69042,
	"./Images/png/chessboard_part_left.png": 20695,
	"./Images/png/chessboard_part_placeholder.png": 57953,
	"./Images/png/chessboard_part_right.png": 47097,
	"./Images/png/chessboard_right_part_large.png": 14334,
	"./Images/png/circle_chess_logo.png": 98073,
	"./Images/png/circle_chess_logo_black.png": 87975,
	"./Images/png/circlechess_screenshot.png": 59135,
	"./Images/png/custom_rules_icon.png": 53786,
	"./Images/png/custom_rules_modal.png": 61817,
	"./Images/png/defeat_result.png": 307,
	"./Images/png/delete.png": 24290,
	"./Images/png/diagonal_chess_part.png": 66013,
	"./Images/png/double_arrow_up.png": 3742,
	"./Images/png/draw.png": 25068,
	"./Images/png/draw_result.png": 19066,
	"./Images/png/dropdown.png": 75604,
	"./Images/png/elevate.png": 98267,
	"./Images/png/empty_book.png": 82470,
	"./Images/png/empty_result.png": 17454,
	"./Images/png/endgame.png": 86420,
	"./Images/png/engine.png": 12545,
	"./Images/png/eye.png": 3396,
	"./Images/png/file.png": 21644,
	"./Images/png/gamesummary.png": 73771,
	"./Images/png/go_back.png": 65451,
	"./Images/png/home.png": 57193,
	"./Images/png/intermediate.png": 91229,
	"./Images/png/late_guess.png": 3654,
	"./Images/png/learning.png": 98259,
	"./Images/png/level_unit_empty.png": 44989,
	"./Images/png/level_unit_filled.png": 608,
	"./Images/png/master.png": 33733,
	"./Images/png/middlegame.png": 68504,
	"./Images/png/mobileOne.png": 47912,
	"./Images/png/newGame.png": 8635,
	"./Images/png/opening.png": 30490,
	"./Images/png/opening2.png": 11723,
	"./Images/png/organisation_trophy.png": 68476,
	"./Images/png/player.png": 46734,
	"./Images/png/random_color.png": 23987,
	"./Images/png/record_button.png": 75375,
	"./Images/png/refresh.png": 95019,
	"./Images/png/resign.png": 56040,
	"./Images/png/review_game.png": 98135,
	"./Images/png/search.png": 86570,
	"./Images/png/settings.png": 16390,
	"./Images/png/settings_close.png": 58946,
	"./Images/png/shopping-bag.png": 43808,
	"./Images/png/signup_assess.png": 46976,
	"./Images/png/signup_elevate.png": 15751,
	"./Images/png/signup_play.png": 9234,
	"./Images/png/square_background.png": 63104,
	"./Images/png/stockfish_settings.png": 61567,
	"./Images/png/stop_record.png": 25490,
	"./Images/png/trash.png": 39241,
	"./Images/png/upload.png": 93296,
	"./Images/png/voice_process.png": 44296,
	"./Images/png/whatsapp_say_hi.png": 91132,
	"./Images/png/whatsapp_share.png": 10738,
	"./Images/png/white_box.png": 60391,
	"./Images/png/white_color.png": 84524,
	"./Images/png/white_rook.png": 33045,
	"./Images/png/win_result.png": 52842,
	"./Sounds/Confirmation.mp3": 4609,
	"./Sounds/correct-sound-square-trainer.mp3": 54022,
	"./Sounds/draw_offer.mp3": 78273,
	"./Sounds/game_resign_countdown_sound.mp3": 40369,
	"./Sounds/game_start.mp3": 47345,
	"./Sounds/levelup.mp3": 19748,
	"./Sounds/notification.mp3": 52609,
	"./Sounds/notification2.mp3": 58882,
	"./Sounds/round_start.mp3": 816,
	"./Sounds/success.mp3": 80402,
	"./Sounds/wrong.mp3": 90300,
	"./blunderDashboardQuestion.svg": 82616,
	"./onboardingScreen1.svg": 9334,
	"./reset10Icon.svg": 77055
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55160;